import { ActivatedRoute, Router } from '@angular/router';
import { Component, HostListener, OnInit } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';

import { EquisNavigatorService } from '@tn-equis/core/services';
import { FaqsService } from 'src/app/core/services/faqs-service/faqs.service';
import { Observable } from 'rxjs';
import { TEXTS_VARIABLE } from 'src/app/shared/constants/constants-texts';
import { NavigatorService } from 'src/app/shared/services/navigator/navigator.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
})
export class SearchComponent implements OnInit {
  texts = TEXTS_VARIABLE;
  param$!: Observable<any>;
  data$!: Observable<any>;
  isMobile: boolean = false;

  constructor(
    private faqsService: FaqsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private equisNavigatorService: EquisNavigatorService,
    private navigatorService: NavigatorService,
  ) {}

  ngOnInit(): void {
    this.isMobile = this.equisNavigatorService.isMobile;
    this.param$ = this.activatedRoute.paramMap.pipe(
      map(params => {
        const id = params.get('id') ?? '';
        this.navigatorService.setSearchTitle(id);
        return id;
      }),
    );

    this.data$ = this.activatedRoute.paramMap.pipe(
      switchMap(params => {
        return this.faqsService.searchFaqs(params.get('id') ?? '');
      }),
    );
  }

  clickQuestion(question: any): void {
    this.router.navigate([`${question.slug}`], {
      queryParamsHandling: 'preserve',
    });
  }

  @HostListener('window:popstate', ['$event'])
  onBrowserBackBtnClose(event: Event): void {
    this.faqsService._showTitleSearchComponent.next(true);
    event.preventDefault();
    this.router.navigate([''], { replaceUrl: true });
  }
}
